export default __webpack_public_path__ + "static/media/twitter.96c5e1ad.svg";